import axios from "axios";
import { projectFilesApi } from "../../../../api/projectFiles";

const sendGpxToServ = ({ blob, projectId }) => {
  const formData = new FormData();
  formData.append("file", blob, "test.gpx"); //ajouter le fichier à un objet FormData

  // Envoyer la requête POST vers le backend en utilisant Axios
  return axios
    .post(projectFilesApi.storeGpx(projectId), formData, {
      withCredentials: true,
    })
    .then((response) => {
      console.log(
        "Le fichier a été envoyé avec succès au serveur:",
        response.data
      );
      // Effectuer d'autres actions avec la réponse du serveur, si nécessaire
    })
    .catch((error) => {
      console.error("Erreur lors de l'envoi du fichier au serveur:", error);
    });
};

export default sendGpxToServ;
